module.exports = __webpack_public_path__ + "6a29a195cbd5405b16ca4743cb5b2e6e.MP3";